<template>
  <div data-testid="admin-console-agent-settings" class="admin-console-agent-settings">
    <div data-testid="admin-console-agent-settings__hero" class="admin-console-agent-settings__hero">
      <h2 data-testid="admin-console-agent-settings__hero-title" class="admin-console-agent-settings__hero-title">
        Agent Settings
      </h2>
      <p data-testid="admin-console-agent-settings__hero-subtitle" class="admin-console-agent-settings__hero-subtitle">
        Select an agent below to get started.
      </p>
    </div>

    <div data-testid="admin-console-agent-settings__grid" class="admin-console-agent-settings__grid">
      <div
        v-for="tile in agentTiles"
        :key="tile.key"
        :data-testid="`admin-console-agent-settings__tile--${tile.key}`"
        class="admin-console-agent-settings__tile"
        role="button"
        tabindex="0"
        @click="onTileClick(tile)"
        @keyup.enter="onTileClick(tile)"
      >
        <h3
          :data-testid="`admin-console-agent-settings__tile-title--${tile.key}`"
          class="admin-console-agent-settings__tile-title"
        >{{ tile.title }}</h3>
        <p
          :data-testid="`admin-console-agent-settings__tile-description--${tile.key}`"
          class="admin-console-agent-settings__tile-description"
        >{{ tile.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ADMIN_CONSOLE_AGENT_TILES, buildAdminConsoleRouteQuery } from '@/modules/admin/utils/adminConsoleConstants';

export default {
  name: 'AgentSettingsLanding',
  computed: {
    agentTiles() {
      if (this.$store.state.accrualsbotEnabled !== true) return [];
      return ADMIN_CONSOLE_AGENT_TILES;
    },
  },
  methods: {
    onTileClick(tile) {
      if (!tile?.route) {
        console.log('[AgentSettingsLanding]:', tile?.key);
        return;
      }

      const query = buildAdminConsoleRouteQuery(this.$route, this.$store.state.client);

      this.$router.push({ path: tile.route, query }).catch((err) => {
        if (err?.name === 'NavigationDuplicated') return;
      });
    },
  },
};
</script>

<style lang="scss" scoped src="./AgentSettingsLanding.scss"></style>
